/**
 * Animation Easing Rules
 *
 * Guidelines:
 * - Default to use `ease-out` for most animations
 * - Animations should be 0.2s to 0.3s (never longer than 1s unless illustrative)
 * - Don't use built-in CSS easings unless it's `ease` or `linear`
 */

// **`ease-in`**: (Starts slow, speeds up) Should generally be avoided as it makes the UI feel slow.
export const EASE_IN = {
  quad: [0.55, 0.085, 0.68, 0.53],
  cubic: [0.55, 0.055, 0.675, 0.19],
  quart: [0.895, 0.03, 0.685, 0.22],
  quint: [0.755, 0.05, 0.855, 0.06],
  expo: [0.95, 0.05, 0.795, 0.035],
  circ: [0.6, 0.04, 0.98, 0.335],
} as const

// **`ease-out`**: (Starts fast, slows down) Best for elements entering the screen or user-initiated interactions.
export const EASE_OUT = {
  quad: [0.25, 0.46, 0.45, 0.94],
  cubic: [0.215, 0.61, 0.355, 1],
  quart: [0.165, 0.84, 0.44, 1],
  quint: [0.23, 1, 0.32, 1],
  expo: [0.19, 1, 0.22, 1],
  circ: [0.075, 0.82, 0.165, 1],
} as const

// **`ease-in-out`**: (Smooth acceleration and deceleration) Perfect for elements moving within the screen.
export const EASE_IN_OUT = {
  quad: [0.455, 0.03, 0.515, 0.955],
  cubic: [0.645, 0.045, 0.355, 1],
  quart: [0.77, 0, 0.175, 1],
  quint: [0.86, 0, 0.07, 1],
  expo: [1, 0, 0, 1],
  circ: [0.785, 0.135, 0.15, 0.86],
} as const
